import { Outlet } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import Logo from "src/components/Logo";
import { FC } from "react";
import LanguagePopover from "../main/header/LanguagePopover";
import { useTranslation } from "react-i18next";

const AuthLayout: FC = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    opacity: 0.5,
                    backgroundImage:
                        "linear-gradient(180deg, rgba(255,238,224,0.15) 0%, rgba(255,217,189,0.15) 100%)",
                    width: "178vw",
                    aspectRatio: "1.62",
                    borderRadius: "50%",
                    position: "absolute",
                    bottom: "45%",
                    left: 0,
                    zIndex: -1,
                    pointerEvents: "none",
                }}
            />
            <Container
                maxWidth="sm"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                    paddingRight: { xs: 0, sm: 2 },
                    paddingLeft: { xs: 0, sm: 2 },
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        pt: 4,
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 3.5 }}>
                        <Logo />
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                right: 16,
                                zIndex: 50,
                            }}
                        >
                            <LanguagePopover />
                        </Box>
                    </Box>
                    <Outlet />
                </Box>
                <Typography
                    variant="caption"
                    sx={{
                        py: 4,
                        px: { xs: 3, sm: 0 },
                        color: "text.disabled",
                        textAlign: "center",
                        textTransform: "uppercase",
                        letterSpacing: 1.1,
                    }}
                >
                    {t("shared.copyright").replace(":year", new Date().getFullYear())}
                </Typography>
            </Container>
        </Box>
    );
};

export default AuthLayout;
